import { forEach } from 'lodash';
import moment from 'moment';
import { JobPhase } from '../../shared/models/jobs';

const WeekLength = 7;

enum Days {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

const weekdaysFormater = (data) => {
  const weekdaysData = (new Array(WeekLength).fill(0)).map((v, k) => {
    return {
      [JobPhase.Cancelled]: 0,
      [JobPhase.Completed]: 0,
      day: Days[k]
    }
  });

  forEach(data,(value) => {
    if (value.completed_time) {
      const dayNumber = moment(value.completed_time).day();
      weekdaysData[dayNumber][JobPhase.Completed] += value.last_phase === JobPhase.Completed ? 1 : 0;
      weekdaysData[dayNumber][JobPhase.Cancelled] += value.last_phase === JobPhase.Cancelled ? 1 : 0;
    }
  });
  return weekdaysData;
};

export default weekdaysFormater;
